package com.schoolconnect.app.datasource.network.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class PlatformUsersResponse(
    val count: Int? = null,
    @SerialName("items")
    val users: List<PlatformUserResponse>? = null
)

@Serializable
data class PlatformUserResponse(
    val id: String? = null,
    @SerialName("user_id")
    val userId: String? = null,
    val name: String? = null,
    val mobile: String? = null,
    val email: String? = null,
    @SerialName("is_active")
    val isActive: Boolean? = null,
    @SerialName("created_at")
    val createdAt: String? = null,
    @SerialName("assignment_id")
    val assignmentId: String? = null,
    @SerialName("role_id")
    val roleId: Int? = null,
    @SerialName("role_title")
    val roleTitle: String? = null,
    val assignment: PlatformUserAssignmentResponse? = null
)

@Serializable
data class PlatformUserAssignmentResponse(
    @SerialName("assignment_id")
    val assignmentId: String? = null,
    @SerialName("role_id")
    val roleId: Int? = null,
    @SerialName("school_id")
    val schoolId: String? = null,
    @SerialName("school_name")
    val schoolName: String? = null,
    @SerialName("school_code")
    val schoolCode: String? = null,
    @SerialName("staff_id")
    val staffId: String? = null,
    @SerialName("employee_id")
    val employeeId: String? = null,
    val gender: String? = null,
    @SerialName("role_title")
    val roleTitle: String? = null
)
